import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileSignature } from "lucide-react";
import { api, currentRole } from "@/lib/api";

export default function SigningReminder() {
  const [s, setS] = useState(null);
  useEffect(() => {
    if (currentRole() === "super_admin") api.get("/admin/agreements-pending").then((r) => setS(r.data)).catch(() => {});
  }, []);
  if (!s || !s.total_pending) return null;
  const parts = [
    s.awaiting_signature && `${s.awaiting_signature} awaiting signature`,
    s.verification_failed && `${s.verification_failed} failed verification`,
    s.not_prepared && `${s.not_prepared} not yet prepared`,
  ].filter(Boolean);
  return (
    <div className="rounded-xl border border-orange-500/40 bg-orange-500/10 p-4 mb-5 flex flex-wrap items-center justify-between gap-3" data-testid="signing-reminder">
      <div className="flex items-start gap-3">
        <FileSignature size={18} className="text-orange-300 shrink-0 mt-0.5"/>
        <div>
          <div className="font-bold text-orange-200"><span className="font-mono text-xl mr-1" data-testid="signing-reminder-count">{s.total_pending}</span>franchise agreement{s.total_pending === 1 ? "" : "s"} need the Director's digital signature</div>
          <div className="text-xs text-orange-200/80 mt-0.5" data-testid="signing-reminder-breakdown">{parts.join(" · ")}</div>
        </div>
      </div>
      <Link to="/admin/agreement-signing" className="text-xs font-semibold text-orange-200 underline underline-offset-4" data-testid="signing-reminder-link">Sign now</Link>
    </div>
  );
}
